import React from 'react';
import PropTypes from 'prop-types';
import 'font-awesome/css/font-awesome.min.css';
import './TableInform.css';

const TableUserForm = ({
  dados,
  exibirExcluir = true,  // Define se o ícone de excluir será exibido
  onExcluir,
}) => {
  const handleExcluir = (index) => {
    onExcluir(index);
  };

  return (
    <table className="tabela">
      <thead>
        <tr>
          <th>Nome</th>
          <th>E-mail</th>
          <th>Ação</th>
        </tr>
      </thead>
      <tbody>
        {dados.map((item) => (
          <tr key={item.uid}>
            <td>{item.userName}</td>
            <td>{item.userEmail}</td>
            <td>
              {exibirExcluir && (
                <button
                  className="tabela-acao tabela-excluir"
                  onClick={() => handleExcluir(item.uid)}
                >
                  <i className="fa fa-trash"></i>
                </button>
              )}
            </td>
          </tr>
        ))}
      </tbody>
    </table>
  );
};

TableUserForm.propTypes = {
  dados: PropTypes.arrayOf(
    PropTypes.shape({
      userName: PropTypes.string.isRequired,
      userEmail: PropTypes.string.isRequired,
      uid: PropTypes.string.isRequired,
    })
  ).isRequired,
  exibirExcluir: PropTypes.bool,  // Propriedade para exibir o ícone de excluir
  onExcluir: PropTypes.func.isRequired,
};

export default TableUserForm;
